// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-name-description-editor-dialog {
  padding: 24px 0 80px;
  display: block;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/name-description-input/name-description-editor-dialog/name-description-editor-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,cAAA;AACJ","sourcesContent":[".fi-name-description-editor-dialog {\r\n    padding: 24px 0 80px;\r\n    display: block;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
